<template>
  <div>
    <div>
      <v-text-field
        ref="input"
        v-model.number="number"
        v-number-only
        :suffix="$store.state.tanimlar.birim.find((el) => el.value === birim).text"
        hide-details
        style="width: 120px"
        light
        solo
        dense
        class="rounded-b-0"
        @blur="onBlurNumber"
        @focus="$event.target.select()"
      >
      </v-text-field>
    </div>

    <div>
      <v-btn
        @click="deleteItem"
        x-small
        depressed
        color="white"
        class="rounded-t-0 rounded-r-0 btn-basket-wight"
      >
        <v-icon color="primary" size="18">
          {{ icons.mdiTrashCan }}
        </v-icon>
      </v-btn>

      <v-btn
        @click="minusNumber(BirimRitim)"
        x-small
        depressed
        color="white"
        class="rounded-0 btn-basket-wight"
      >
        <v-icon color="primary" size="18">
          {{ icons.mdiMinusThick }}
        </v-icon></v-btn
      >

      <v-btn
        x-small
        @click="addNumber(BirimRitim)"
        depressed
        color="white"
        class="rounded-t-0 rounded-l-0 btn-basket-wight"
      >
        <v-icon color="night" size="18">
          {{ icons.mdiPlusThick }}
        </v-icon></v-btn
      >
    </div>
  </div>
</template>

<script>
import store from "@/store";
import { mdiMinusThick, mdiPlusThick, mdiTrashCan } from "@mdi/js";
import { onMounted, ref, watch } from "@vue/composition-api";

export default {
  directives: {
    "number-only": {
      bind(el) {
        function checkValue(event) {
          event.target.value = event.target.value.replace(/[^0-9]/g, "");
          if (event.charCode >= 48 && event.charCode <= 57) {
            return true;
          }
          event.preventDefault();
        }
        el.addEventListener("keypress", checkValue);
      },
    },
    "letter-only": {
      bind(el) {
        function checkValue(event) {
          if (event.charCode >= 48 && event.charCode <= 57) {
            event.preventDefault();
          }

          return true;
        }
        el.addEventListener("keypress", checkValue);
      },
    },
  },
  props: {
    bgColor: {
      type: String,
      default: "secondary",
    },
    uid: {
      default: null,
    },
    plantId: {
      type: String,
      default: "01",
    },
    buttonColor: {
      type: String,
      default: "white",
    },
    birimRitim: {
      type: Number,
      default: 50,
    },
    birim: {
      type: String,
      default: "Adet",
    },
    miktar: {
      type: [String, Number],
      default: "1",
    },
    dark: {
      type: Boolean,
      default: false,
    },
    status: {
      type: Boolean,
      default: true,
    },
    light: {
      type: Boolean,
      default: false,
    },
    count: {
      type: Boolean,
      default: true,
    },
    filled: {
      type: Boolean,
      default: true,
    },
    solo: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["select", "refresh", "deleteBasketItem"],
  setup(props, { emit }) {
    const number = ref(1);
    const Birim = ref(props.birim);
    const BirimRitim = ref(props.birimRitim);
    const BgColor = ref(props.bgColor);
    const ButtonColor = ref(props.buttonColor);
    const refresh = () => {
      emit("refreshBasket");
    };

    const deleteItem = () => {
      emit("deleteBasketItem", { baslik: "", id: props.uid, plant: props.plantId });
    };

    const addBasket = (qty) => {
      if (props.birimRitim == 2) {
        qty = qty + (qty % 2);
        number.value = qty;
      }
      store
        .dispatch("app-order/fetchAddToBasket", {
          method: "addToBasket",
          uid: props.uid,
          qty,
          plant: props.plantId,
        })
        .then((response) => {
          if (response.error) {
          } else {
            store.dispatch("refreshRiskLimit");
            refresh();
          }
        });
    };

    const addNumber = (val) => {
      number.value += Number(val) - Number(number.value % val);
      if (props.status) {
        addBasket(number.value);
      }
    };
    onMounted(() => {
      number.value = Number(props.miktar);
    });

    const select = () => {
      emit("selected", number);
    };

    watch(
      () => props.miktar,
      (newValue) => {
        number.value = newValue;
      }
    );

    watch(number, () => {
      select();
    });

    const onBlurNumber = (val) => {
      addBasket(number.value);
    };
    // eslint-disable-next-line no-return-assign
    const minusNumber = (val) => {
      number.value != 1
        ? (number.value -=
            Number(number.value % val) === 0 ? Number(val) : Number(number.value % val))
        : 1;
      if (number.value === 0) {
        number.value = 1;
      }
      addBasket(number.value);
    };

    return {
      Birim,
      number,
      select,
      deleteItem,
      BgColor,
      ButtonColor,
      BirimRitim,
      addNumber,
      minusNumber,
      onBlurNumber,
      icons: {
        mdiPlusThick,
        mdiMinusThick,
        mdiTrashCan,
      },
    };
  },
};
</script>

<style lang="scss">
.completed {
  label,
  .v-text-field__suffix,
  input {
    color: #3b355a !important;
    text-shadow: none !important;
  }
}
.btn-basket-wight {
  width: 40px !important;
}
</style>
